import * as Sentry from "@sentry/browser"
import { RewriteFrames } from "@sentry/integrations"
import * as React from "react"
import { render } from "react-dom"
import { AppsRouter } from "./common/AppsRouter"
import { appElement, AppType } from "./common/AppType"
import { TextUtils } from "./common/TextUtils"

// This allows TypeScript to detect our global sentry value
declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace NodeJS {
        interface Global {
            __rootdir__: string
        }
    }
}

global.__rootdir__ = __dirname || process.cwd()

Sentry.init({
    dsn: "https://282a2b304f7b49048fc712b641cf4ae5@sentry.io/1518744",
    integrations: [
        new RewriteFrames({
            root: global.__rootdir__,
        }),
    ],
    release: process.env.RELEASE,
})

window.onload = async () => {
    TextUtils.loadFonts()

    const reactApp = appElement(AppType.REACT)

    render(<AppsRouter />, reactApp)

    // new MainGame()
    // According to the docs for SoundManager you should do this if you don't fully refresh the page.
    // https://photonstorm.github.io/phaser-ce/Phaser.SoundManager.html
    window["PhaserGlobal"] = {}
}
